<template>
	<div class="frame_bottom">
		<!-- 底部信息 开始-->
		<div class="footer">
		  <div class="fWap">
		    <div class="w1200">
		      <div class="linkWap">
		        <div class="drop"><img src="/images/drop.png"/></div>
		        <ul>
		          <li><a href="http://reportnew.cei.cn/">行业发展报告库</a></li>
		          <li><a href="https://region.cei.cn/">区域监测评价系统</a></li>
		          <li><a href="https://ceidata.cei.cn/">中经数据</a></li>
		          <li><a href="http://vodgov.cei.cn/">中经视频</a></li>
		        </ul>
		      </div>
		      <div class="content">
		        <div class="drop"><img src="/images/drop.png"/></div>
		        <dl class="w50">
		          <dd>
		            <p><i>客户服务：</i>010-68558322<br/>market@cei.cn</p>
		            <p><i>内容咨询：</i>010-68140950<br/>region@cei.cn</p>
		            <p style="padding-left: 0; padding-top:48px">地址：北京市西城区三里河路58号国家信息中心</p>
		          </dd>
		          <dd style="text-align: right">
		            <ul>
		              <li>
		                <img src="/images/ma_gzh.jpg" width="118px" height="118px"/>
		                <span>官方公众号</span>
		              </li>
		              <li>
		                <img src="/images/ma_xcx.jpg" width="118px" height="118px"/>
		                <span>小程序</span>
		              </li>
		            </ul>
		          </dd>
		        </dl>
		      </div>      
					<div class="announce">
					  <div class="drop"><img src="/images/drop.png"/></div>
					  <div style="color: white;text-align: center;padding: 20px 0px;">
							本网注明"来源：中国经济信息网"的文字、图片和音视频作品，版权归中国经济信息网所有。未经许可，禁止擅自转载、复制、传播或使用本文内容，中国经济信息网保留一切法律追究的权利。转载的内容并不代表本网站认同其观点或真实性。原文版权归原作者所有。如有侵权，请联系删除。<br />
							数据指数主要来源于：各级政府部门；时事新闻；国家权威研究机构的研究成果、白皮书、通知声明等。数据指数提供的数据和信息与中国经济信息网观点和立场无关。
						</div>
					</div>
		    </div>
		  </div>
		  <div class="fLink">
		    <div class="w1200">
		      <ul class="w60percent">
		        <li><a @click="trackClick('/pdf/Company Profile.pdf','公司简介')">公司简介</a></li>
		        <li><a @click="trackClick('/pdf/Product Introduction.pdf','产品介绍')">产品介绍</a></li>
		        <li><a @click="trackClick('/pdf/Product Manuals.pdf','使用手册')">使用手册</a></li>
		        <li><span @click="trackClick('','友情链接')" id="link">友情链接</span></li>
		        <li><span @click="trackClick('','联系我们')" id="content">联系我们</span></li>
						<li><span @click="trackClick('','免责声明')" id="announce">免责声明</span></li>
		      </ul>
					<div class="footeradvise">
						<span>建议分辨率1366 * 768以上，推荐谷歌浏览器</span>
					</div>
		    </div>
		  </div>
		</div>
		<!-- 底部信息 结束-->
	</div>
	
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		created: function() {
			
		},
		mounted() {

		},
		computed: {
	
		},
		methods: {
			trackClick:function(url,type){
				this.$track([
					['pagetype','底栏-'+type+'-点击'],
				]);
				if(url){
					window.location.href=url;
				}
			},
		}
	}
</script>

<style>
</style>
